<template>
    <div>
        <Navbar/>
        <section class="section">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8">
                        <article align="justify" class="content">
                            <div class="content__header">
                                <h1><strong>{{$t('connection_txt_title1')}}</strong></h1>
                            </div>
                            <h3><strong>{{$t('connection_txt_subtitle1')}}</strong></h3>
                            <div v-html="$t('connection_txt1')"></div>
                            <h3><strong>{{$t('connection_txt_subtitle2')}}</strong></h3>
                            <div v-html="$t('connection_txt2')"></div>
                            <h3><strong>{{$t('connection_txt_subtitle3')}}</strong></h3>
                            <div v-html="$t('connection_txt3')"></div>
                            <div v-html="$t('connection_txt4')"></div>
                        </article>
                    </div>
                </div>
            </div>
        </section>
        <Footer/>
    </div>
</template>

<script>
import Navbar from '@/views/landing/Navbar'
import Footer from '@/views/landing/Footer'

export default {
  name: 'Connection',
  components: {
    Navbar,
    Footer
  }
}
</script>

<style scoped>

</style>
